export const TABS = {
  COMMENTS: 'comments',
  TASKS: 'tasks',
  CALENDAR: 'calendar',
  APPROVALS: 'approvals',
  COPILOT: 'copilot'
};